import type { FormatDateOptions } from 'react-intl';
import { useIntl } from 'react-intl';

import { getSafeMilliseconds } from '@swf/poker';

const formatOpts: FormatDateOptions = {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'UTC',
  timeZoneName: 'short'
};

const useFormatDateBySeconds = (date: string | number | undefined) => {
  const { formatDate } = useIntl();
  return getSafeMilliseconds(date) ? formatDate(getSafeMilliseconds(date), formatOpts) : '';
};

export default useFormatDateBySeconds;
